import React, { FunctionComponent } from 'react';

import ManifestationModificationForm from './ManifestationModificationForm';
import Step from 'src/components/common/Step';

interface ManifestationModificationModalContentProps {
  currentStep: number;
  onClose: () => void;
  onNext: () => void;
  onPrevious: () => void;
  onSubmit: () => void;
  patientId: string;
  setRecord: (record: any) => void;
  record: any;
}

export const ManifestationModificationModalContent: FunctionComponent<ManifestationModificationModalContentProps> =
  ({ currentStep, onClose, onPrevious, patientId, record }) => {
    return (
      <>
        <Step step={0} currentStep={currentStep}>
          <ManifestationModificationForm
            patientId={patientId}
            manifestation={record}
            onClose={onClose}
            onPrevious={onPrevious}
          />
        </Step>
      </>
    );
  };

export default ManifestationModificationModalContent;
